export const cookies = {
  /**
   * Get cookies.
   * @param {string} name - The name of a specific cookie.
   * @returns {Object[]} - A specific cookie or all cookies if no name is specified.
   */
  get: name => {
    let documentCookies = document.cookie.split(/; */);
    documentCookies = documentCookies.reduce((params, cookie) => {
      let [key, val] = cookie.split("=");
      return Object.assign(params, {
        [key]: val
      });
    }, {});
    if (name) {
      return documentCookies[name];
    }
    return documentCookies;
  },
  /**
   * Sets cookies.
   * @param {Object[]} cookie - The cookie to be written.
   * @type {Date} cookie.expires - The expiry date: must be UTCString
   * @type {String} cookie.path - The path of the cookie
   * @returns {Object[]}- The newly created cokie.
   */
  set: cookie => {
    let newCookie;
    let expiryDate = new Date();
    if (!cookie.name || !cookie.value) {
      return false;
    }
    newCookie = cookie.name + "=" + cookie.value;
    expiryDate.setDate(expiryDate.getDate() + 5);
    if (cookie.path) {
      newCookie += ";path=" + cookie.path;
    } else {
      newCookie += ";path=/";
    }
    if (cookie.expires) {
      newCookie += ";expires=" + cookie.expires;
    } else {
      newCookie += ";expires=" + expiryDate.toUTCString();
    }
    document.cookie = newCookie;
    return newCookie;
  }
};